import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './global.css';
import { HashRouter } from 'react-router-dom';
import { globalStore } from './GlobalStore';
import { Global } from './Global';

Global.setStaticMode(globalStore.staticMode); 

// 创建加载提示 DOM
const loadingHtml = `
  <div id="loading-wrapper">
    <div id="loading-text">
      系统正在初始化<span class="loading-dots"></span>
    </div>
  </div>
`;
document.body.insertAdjacentHTML('afterbegin', loadingHtml);

const container = document.getElementById('root');
const root = createRoot(container!);

// 在应用加载完成后移除加载提示
const removeLoading = () => {
  const loadingElement = document.getElementById('loading-wrapper');
  if (loadingElement) {
    loadingElement.style.opacity = '0';
    loadingElement.style.transition = 'opacity 0.5s';
    setTimeout(() => {
      loadingElement.remove();
    }, 500);
  }
};

root.render(
  <Suspense fallback={null}>
    <HashRouter>  
      <App onLoad={removeLoading}/> 
    </HashRouter>
  </Suspense>
);